

import Promotion from "@core/Promotion.js";
import {$date, $util} from "@util/util.js";

export default class SubscribeSnap extends Promotion{
    constructor(){
        super();

        this._leftTime = "";
        this._desc = "";
        this._lastDesc = "";

        // this._currentTime = _engine._currentTime;
    }

    //预约开始倒计时：reservationStartTime - current
    //预约结束倒计时：reservationEndTime - current
    //抢购开始倒计时：startTime - current
    //抢购结束倒计时：endTime - current

    init(data){
        this._id = data.id;
        this._name = "预约抢购";
        this._type = data.type;
        this._startTime = data.startTime;
        this._endTime = data.endTime;
        this._reservationStartTime = data.reservationStartTime;
        this._reservationEndTime = data.reservationEndTime;
        this._inBuyTime = data.inBuyTime;
        this._purchaseCeiling = data.purchaseCeiling;
        this._timestamp = data.timestamp;
        this._isCanScribe = false;
        this._showPriceTime = data.showPriceTime;// 价格公布时间
        this._flags = null
        this.tick();
    }

    //1：预约开始倒计时
    //2：预售结束倒计时
    //3：抢购开始倒计时
    //4：抢购结束倒计时
    getTimeQuantum(){
        if($date.compareData(this._reservationStartTime, this._currentTime)){
            return 1;
        }
        if($date.compareData(this._currentTime, this._reservationStartTime) && $date.compareData(this._reservationEndTime, this._currentTime)){
            return 2;
        }
        if($date.compareData(this._currentTime, this._reservationEndTime) && $date.compareData(this._startTime, this._currentTime)){
            return 3;
        }
        if($date.compareData(this._currentTime, this._startTime) && $date.compareData(this._endTime, this._currentTime)){
            return 4;
        }
    }

    getLeftInfo(){
        //任意一个时间相等都刷新页面，重置所有
        if($date.equalTime(this._currentTime, this._reservationStartTime)){
            window.location.href = window.location.href;
        }
        if($date.equalTime(this._currentTime, this._reservationEndTime)){
            window.location.href = window.location.href;
        }
        if($date.equalTime(this._currentTime, this._startTime)){
            window.location.href = window.location.href;
        }
        // 价格公布时间
        if(this._showPriceTime && $date.equalTime(this._currentTime, this._showPriceTime)){
            window.location.href = window.location.href;
        }
        if($date.equalTime(this._currentTime, this._endTime)){
            window.location.href = window.location.href;
        }
        let flag = this.getTimeQuantum();
        this._flags = this.getTimeQuantum();
        if(flag == 1){
            // this._desc = '距预约开始';
            // this._leftTime = $util.countDown.doCountDown(this._currentTime, this._reservationStartTime);
            // this._lastDesc = "去预约";
            this._desc = '';
            this._leftTime = '';
            this._lastDesc = '';
        }
        if(flag == 2){
            this._desc = '距预约结束还剩';
            this._leftTime = $util.countDown.doCountDown(this._currentTime, this._reservationEndTime);
            this._lastDesc = "去预约";
            this._isCanScribe = true;
        }
        if(flag == 3){
            this._desc = '距抢购开始还有';
            this._leftTime = $util.countDown.doCountDown(this._currentTime, this._startTime);
            this._lastDesc = "";
        }
        if(flag == 4){
            this._desc = '距抢购结束还剩';
            this._leftTime = $util.countDown.doCountDown(this._currentTime, this._endTime);
            this._lastDesc = "去抢购";
            this._isCanScribe = true;
        }
        // this._currentTime = this._currentTime + 1000;
    }

    tick(){
        const nowDate = new Date();
        this._currentTime = nowDate.getTime()+_engine._timeDiff;
        this.getLeftInfo();      
        window.setInterval(()=>{
            const nowDate = new Date();
            this._currentTime = nowDate.getTime()+_engine._timeDiff;
            this.getLeftInfo();        
        },1000)
    }
}